const redirectDomain = process.env.AWS_ENVIRONMENT === 'prod' ? 'www.pff' : 'www.pffstaging'
export const redirectBaseUrl = `https://${redirectDomain}.com`
